var servicesReportDialog = {
  dialogBoxDom: document.querySelector('#services-report-dialog'),
  maskDom: document.querySelector('#services-report-dialog').querySelector('.mask'),
  dialogDom: document.querySelector('#services-report-dialog').querySelector('.container'),
  vueObject: null,
  reportDialog: document.querySelector('.report-dialog-box'),

  vueExp: function () {
    var dialogObj = this;
    this.vueObject = new Vue({
        el: "#vue-services-report-dialog",
        data: {
          form: {
            formList: {
              name: {
                fieldName: 'name',
                label: '姓名',
                placeholder: '请输入您的姓名',
                value: getUserInfo.options.name || '',
                type: 'text',
                isShowError: false,
                isRequired: true,
                reg: '',
                errorText: '',
                errorTextContent: '',
                errorTextEmpty: '请输入您的姓名',
              },
              mobile: {
                fieldName: 'mobile',
                label: '手机号码',
                placeholder: '请输入您的手机号',
                value: getUserInfo.options.mobile || '',
                type: 'text',
                isShowError: false,
                isRequired: true,
                reg: /^1\d{10}$/,
                errorText: '',
                errorTextContent: '请输入正确的手机号',
                errorTextEmpty: '请输入您的手机号',
              },
              email: {
                fieldName: 'email',
                label: '邮箱（用于接收“戴尔资产报告”）',
                placeholder: '请输入您的邮箱',
                value: getUserInfo.options.email || '',
                type: 'text',
                isShowError: false,
                isRequired: true,
                reg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
                errorText: '',
                errorTextContent: '请输入正确的邮箱',
                errorTextEmpty: '请输入您的邮箱',
              },
              compName: {
                fieldName: 'compName',
                label: '公司名称（设备使用方公司全称）',
                placeholder: '请输入公司名称',
                value: getUserInfo.options.enterpriseName || '',
                type: 'text',
                isShowError: false,
                isRequired: true,
                reg: '',
                errorText: '',
                errorTextContent: '',
                errorTextEmpty: '请输入公司名称',
              },
              position: {
                fieldName: 'position',
                label: '职位',
                placeholder: '请输入您的职位',
                value: getUserInfo.options.position || '',
                type: 'text',
                isShowError: false,
                isRequired: false,
                reg: '',
                errorText: '',
                errorTextContent: '',
                errorTextEmpty: '请输入您的职位',
              },
              number: {
                fieldName: 'number',
                label: '设备服务编号（多个设备号以逗号间隔）',
                placeholder: '请输入设备服务编号',
                value: '',
                type: 'text',
                isShowError: false,
                isRequired: true,
                reg: '',
                errorText: '',
                errorTextContent: '',
                errorTextEmpty: '请输入设备服务编号',
              },
            },
          },
        },
        created: function () {
        },
        mounted: function () {
          new selectCompany('.consult-form-box .form-item:nth-child(4) input')
        },
        methods: {
          //验证表单
          verifyForm: function () {
            var flag = true;
            for (var item in this.form.formList) {
              var itemObj = this.form.formList[item];
              if (this.verify(itemObj) === false) {
                flag = false;
              }
            }
            return flag;
          },
          // 验证程序
          verify: function (itemObj) {
            var flag = true;
            if (itemObj.isRequired && itemObj.value === '') {
              itemObj.isShowError = true;
              itemObj.errorText = itemObj.errorTextEmpty ? itemObj.errorTextEmpty : '请输入' + itemObj.label;
              flag = false;
              return flag;
            }
            if (itemObj.reg && itemObj.value) {
              itemObj.isShowError = !itemObj.reg.test(itemObj.value);
              if (itemObj.isShowError) {
                itemObj.isShowError = true;
                itemObj.errorText = itemObj.errorTextContent ? itemObj.errorTextContent : '您输入的' + itemObj.label + '错误';
                flag = false;
              }
            }
            if (flag) {
              itemObj.isShowError = false;
              itemObj.errorText = '';
            }
            return flag;
          },
          submit: function () {
            var _this = this;

            if (!_this.verifyForm()) {
              console.log('验证不通过')
              return;
            } else {
              var params = {
                customFormId: 2203170924385681,
                globalUserId: common.getGlobalUserId(),
                instanceId: null,
                referenceUrl: "",
                linkId: "41025",
                items: [
                  {
                    fieldName: "name",
                    value: _this.form.formList.name.value
                  },
                  {
                    fieldName: "mobile",
                    value: _this.form.formList.mobile.value
                  },
                  {
                    fieldName: "email",
                    value: _this.form.formList.email.value
                  },
                  {
                    fieldName: "enterprise_name",
                    value: _this.form.formList.compName.value
                  },
                  {
                    fieldName: "custom_form_field_1647595993278",
                    value: _this.form.formList.position.value
                  },
                  {
                    fieldName: "custom_form_field_1647496704107",
                    value: _this.form.formList.number.value
                  },
                  {
                    fieldName: "custom_form_field_1566885262493",
                    value: '戴尔企采会员中心'
                  },
                  {
                    fieldName: "custom_form_field_1568974162907",
                    value: '戴尔企采会员中心'
                  },
                  {
                    fieldName: "linksource",
                    value: ''
                  },
                  {
                    fieldName: "utmSource",
                    value: common_utmObj.utm_source
                  },
                  {
                    fieldName: "utmMedium",
                    value: common_utmObj.utm_medium
                  },
                  {
                    fieldName: "utmCampaign",
                    value: common_utmObj.utm_campaign
                  },
                  {
                    fieldName: "utmContent",
                    value: common_utmObj.utm_content
                  },
                  {
                    fieldName: "utmTerm",
                    value: common_utmObj.utm_term
                  },
                  {
                    fieldName: "interests",
                    value: ''
                  },
                  {
                    fieldName: "modulesources",
                    value: '戴尔企采会员中心'
                  }
                ],
                ver: 'v2.0.1',
                sess: isLogin().session || '',
                openId: common.isWx ? common.getCookie('dell_wx_openid') : '',
                isBind: common.isWx ? true : '',
                weChatId: common.isWx ? window.cateData.weChatId : '',
              }
              common.postJson(window.urlConfig.api + '/customForm/action', params, function (res) {
                if (res.body.result == 0) {
                  dialogObj.hideDialog();
                  dialogObj.showSmallDialog();
                  gioTrackAction.servicesReportformsubmit(
                    {
                      'userName': _this.form.formList.name.value,
                      'phoneNumber': _this.form.formList.mobile.value,
                      'company': _this.form.formList.compName.value,
                      'email': _this.form.formList.email.value,
                    }
                  )
                } else {
                  msg.toast(res.body.error)
                }
              })
            }
          },
          closeDialog: function () {
            dialogObj.hideDialog();
          },
          closeSmallDialog: function () {
            dialogObj.hideSmallDialog();
          }
        },
        watch: {}
      }
    )
  },
  showDialog: function () {
    var _this = this;
    getUserInfoDef.then(function () {
      if (!_this.vueObject) {
        _this.vueExp();
      }
      gioTrackAction.servicesReportclick();
      _this.dialogBoxDom.style.display = 'block';
      _this.dialogDom = document.querySelector('#services-report-dialog').querySelector('.container');
      //禁止后方滚动
      setScroll.unScroll();
    });
  },
  showSmallDialog: function () {
    this.reportDialog.style.display = 'block';
    setScroll.unScroll();
  },
  hideSmallDialog: function () {
    this.reportDialog.style.display = 'none';
    common.gotoUrl('/services/guarantee', false);

    //允许后方滚动
    setScroll.removeUnScroll();
  },
  hideDialog: function () {
    var _this = this;
    setTimeout(function () {
      _this.dialogBoxDom.style.display = 'none';
    }, 200);

    //允许后方滚动
    setScroll.removeUnScroll();

  },
  showLoading: function () {
    document.querySelector('.login-dialog-loading').style.display = 'block';
    //禁止后方滚动
    setScroll.unScroll();
  },
  hideLoading: function () {
    document.querySelector('.login-dialog-loading').style.display = 'none';
    //允许后方滚动
    setScroll.removeUnScroll();
  },

  init: function () {
  }
};
